import styled from 'styled-components';

// Calendar Event Render Prop
export const EventCard = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  padding: 5px 0;
`;

export const EventTitle = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: #2C343A;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  margin: 5px 0;
  word-break: break-word;
  &::before {
    content: "";
    position: absolute;
    left: 0;
    border-radius: 20px;
    transform: translateY(-50%);

    ${({ color = "#818381", isAllDay = false, isMultiDay = false }) => `
    top: 20px;
    background-color: ${color};
    width: 7px;
    height: 40px;
    margin-top: 0px;
  `}


    ${({ theme }) => theme.breakPoints.tablet} {
      ${({ color = "#818381", isAllDay = false, isMultiDay = false }) => `
      top: ${!isAllDay && !isMultiDay ? "8px" : "20px"};
      background-color: ${color};
      width: 7px;
      height: ${isMultiDay ? "60px" : isAllDay ? "50px" : "7px"};
      margin-top:  ${isMultiDay ? "10px" : "0px"};
    `}
    }
  }
`;

export const EventHour = styled.div`
  font-size: 0.8rem;
  margin: 5px 0;
  color: #808184;
  padding-left: 18px;
`;

export const EventLocation = styled.p`
  font-size: 0.8rem;
  font-weight: 400;
  color: #ACC2D3;
  margin: 5px 0;
  display: flex;
  align-items: baseline;
  position: relative;
  padding-left: 18px;
  margin: 0;
  white-space: pre-line;
  text-overflow: ellipsis;
  word-break: break-word;
  &::before {
    content: "";
    position: absolute;

    left: -2px;
    width: 20px;
    height: 20px;
    background-repeat: no-repeat;
    top: -7px;
    zoom: 1.8;
  }
`;

export const EventSeeMore = styled.img`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: -14px;
  height: 100%;
  padding: 10px;
  width: 46px;
`;

export const EventHourLabel = styled.p`
  color: #808184;
  margin: 0;
  font-size: 14px;
  margin-bottom: 2px;
`;

export const NavigationHeader = styled.div`
  
`;

export const NavigationHeaderText = styled.h2`
  
`;

export const IconLink = styled.img`
position: absolute;
width: ${props => (props.isMeetingIcon ? '15px' : '10px')};
left: ${props => (props.isMeetingIcon ? '-3px' : '-2px')};
`;

export const EventHourWrapper = styled.div`
display: none;
${({ theme }) => theme.breakPoints.tablet} {
  display: block;
  text-transform: capitalize;
}
`;

export const EventLabelHourWrapper = styled.div`
display: block;
${({ theme }) => theme.breakPoints.tablet} {
  display: none;
}
`;
